"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$ = exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$outboundSchema = exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$inboundSchema = exports.QueryParamFieldsProperty$ = exports.QueryParamFieldsProperty$outboundSchema = exports.QueryParamFieldsProperty$inboundSchema = exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$ = exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$outboundSchema = exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$inboundSchema = void 0;
exports.postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurityToJSON = postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurityToJSON;
exports.postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurityFromJSON = postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurityFromJSON;
exports.queryParamFieldsPropertyToJSON = queryParamFieldsPropertyToJSON;
exports.queryParamFieldsPropertyFromJSON = queryParamFieldsPropertyFromJSON;
exports.postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequestToJSON = postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequestToJSON;
exports.postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequestFromJSON = postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$;
(function (PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$) {
    /** @deprecated use `PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$inboundSchema` instead. */
    PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$.inboundSchema = exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$inboundSchema;
    /** @deprecated use `PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$outboundSchema` instead. */
    PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$.outboundSchema = exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$outboundSchema;
})(PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$ || (exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$ = PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$ = {}));
function postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurityToJSON(postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity) {
    return JSON.stringify(exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$outboundSchema
        .parse(postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity));
}
function postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostSecurity' from JSON`);
}
/** @internal */
exports.QueryParamFieldsProperty$inboundSchema = z.union([
    shared.MultiplePropertyUserFields$inboundSchema,
    shared.PropertyUserFields$inboundSchema,
]);
/** @internal */
exports.QueryParamFieldsProperty$outboundSchema = z.union([
    shared.MultiplePropertyUserFields$outboundSchema,
    shared.PropertyUserFields$outboundSchema,
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var QueryParamFieldsProperty$;
(function (QueryParamFieldsProperty$) {
    /** @deprecated use `QueryParamFieldsProperty$inboundSchema` instead. */
    QueryParamFieldsProperty$.inboundSchema = exports.QueryParamFieldsProperty$inboundSchema;
    /** @deprecated use `QueryParamFieldsProperty$outboundSchema` instead. */
    QueryParamFieldsProperty$.outboundSchema = exports.QueryParamFieldsProperty$outboundSchema;
})(QueryParamFieldsProperty$ || (exports.QueryParamFieldsProperty$ = QueryParamFieldsProperty$ = {}));
function queryParamFieldsPropertyToJSON(queryParamFieldsProperty) {
    return JSON.stringify(exports.QueryParamFieldsProperty$outboundSchema.parse(queryParamFieldsProperty));
}
function queryParamFieldsPropertyFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.QueryParamFieldsProperty$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'QueryParamFieldsProperty' from JSON`);
}
/** @internal */
exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$inboundSchema = z.object({
    AddressMatchPostRequest: shared.AddressMatchPostRequest$inboundSchema,
    "fields[property]": z.array(z.union([
        shared.MultiplePropertyUserFields$inboundSchema,
        shared.PropertyUserFields$inboundSchema,
    ])),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "AddressMatchPostRequest": "addressMatchPostRequest",
        "fields[property]": "fieldsProperty",
    });
});
/** @internal */
exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$outboundSchema = z.object({
    addressMatchPostRequest: shared.AddressMatchPostRequest$outboundSchema,
    fieldsProperty: z.array(z.union([
        shared.MultiplePropertyUserFields$outboundSchema,
        shared.PropertyUserFields$outboundSchema,
    ])),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        addressMatchPostRequest: "AddressMatchPostRequest",
        fieldsProperty: "fields[property]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$;
(function (PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$) {
    /** @deprecated use `PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$inboundSchema` instead. */
    PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$.inboundSchema = exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$inboundSchema;
    /** @deprecated use `PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$outboundSchema` instead. */
    PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$.outboundSchema = exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$outboundSchema;
})(PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$ || (exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$ = PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$ = {}));
function postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequestToJSON(postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest) {
    return JSON.stringify(exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$outboundSchema
        .parse(postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest));
}
function postAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'PostAddressMatchV2ExactPropertiesAddressMatchV2ExactPostRequest' from JSON`);
}
//# sourceMappingURL=postaddressmatchv2exactpropertiesaddressmatchv2exactpost.js.map